import { useMemo } from "react";
import IFormType from "../../interfaces/IFormType";
import { useFormTypeList } from "./useFormTypeList";

export type IUseFormTypeByGuidHook = (guid: IFormType["guid"]) => {
    data: IFormType;
    fetching: boolean;
}

export const useFormTypeByGuid: IUseFormTypeByGuidHook = (guid) => {
    const { data: formTypeList, fetching } = useFormTypeList()

    const rawData = useMemo(() => formTypeList.find((type) => type.guid === guid), [formTypeList, guid]);
    if (!rawData) {
        throw Error("Cannot find formType by guid " + guid);
    }
    return useMemo(() => ({ data: rawData, fetching, }), [rawData, fetching]);
};
